var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    viewBox: "0, 0, 24, 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.024,3.527 C15.545,3.527 18.399,6.493 18.399,10.152 L18.399,15.339 L20.344,18.465 L11.781,18.465",
    fillOpacity: 0,
    stroke: "#FDF5F0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.976,3.527 C8.455,3.527 5.601,6.493 5.601,10.152 L5.601,15.339 L3.656,18.465 L12.219,18.465",
    fillOpacity: 0,
    stroke: "#FDF5F0",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125,4.527 C11.107,4.527 10.281,3.757 10.281,2.808 C10.281,1.859 11.107,1.089 12.125,1.089 C13.143,1.089 13.969,1.859 13.969,2.808 C13.969,3.757 13.143,4.527 12.125,4.527 z",
    fill: "#FDF5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125,22.161 C10.33,22.161 8.875,20.705 8.875,18.911 C8.875,18.348 15.437,18.285 15.375,18.911 C15.375,20.705 13.92,22.161 12.125,22.161 z",
    fillOpacity: 0,
    stroke: "#FDF5F0",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.5d6b5c8e3ec55b2a1ae6341ff01c9de2.svg";
export { ForwardRef as ReactComponent };